import Role from "./role";

const Slots = {
  NONE: 0,
  WEAPON: 1,
  ARMOR: 2,
  INVENTORY: 3
}

// Get most frequent quality
// function mostFrequent(arr){
//     return [...arr].sort((a,b) =>
//           arr.filter(v => v===a).length
//         - arr.filter(v => v===b).length
//     ).pop();
// }

class Equipment {
  static blankSheet() {
    return new Equipment(false, false, [], false);
  }

  constructor(weapon, armor, inventory, quiver) {
    this.weapon = weapon;
    this.armor = armor;
    this.inventory = inventory;
    this.quiver = quiver;
    this.hasEquippedWeapon = false;
  }

  isEmpty() {
    return !this.weapon && !this.armor && !this.quiver && this.inventory.length == 0;
  }

  get quality() {
    if (this.inventory.length == 0) {
      if (this.weapon) return this.weapon.item.quality;
      if (this.armor) return this.armor.item.quality;
      if (this.quiver) return this.quiver.item.quality;
      return "Humble";
    } else {
      // TODO: this creates too much garbage
      const qualities = this.inventory.map(obj => obj.item.quality);

      return qualities.sort((a,b) =>
            qualities.filter(v => v===a).length
          - qualities.filter(v => v===b).length
      ).pop();
    }
  }

  isMirrorEquipped() {
    return this.weapon && this.weapon.isReflective();
  }

  isRangedWeaponEquipped() {
    // TODO: there must be a better way to do this
    if (!this.weapon) return false;
    if (!this.weapon.isWeapon()) return false;
    if (!this.quiver) return false;

    const active = this.weapon.weapon;
    return active.type == "ranged" && active.ammunition.type == this.quiver.type;
  }

  consumeShot() {
    const shot = {
      ammunition: this.quiver.name,
      damage: this.quiver.ammunition.damage
    }

    this.quiver.ammunition.quantity--;

    if (this.quiver.ammunition.quantity == 0) {
      this.quiver = false;
    }

    return shot;
  }

  get activeWeaponDamage() {
    return this.weapon && this.weapon.isWeapon() ? this.weapon.weapon.damage : 1;
  }

  canAddItem(item) {
    return (item.isWeapon() && !this.weapon) || this.inventory.length < 10;
  }

  addItem(item) {
    if (item.isWeapon() && !this.weapon) {
      this.weapon = item;

      // If this is the first weapon picked up then select a new role
      // TODO: move this to a callback on the weapons themselves
      if (this.owner.isPlayer() && !this.hasEquippedWeapon) {
        if (this.weapon.name == "Crook") {
          this.owner.role.changeTitle(Role.SHEPHERD);
        } else if (this.weapon.name == "Farm Axe") {
          this.owner.role.changeTitle(Role.WOODCUTTER);
        } else if (this.weapon.name == "Hunting Bow") {
          this.owner.role.changeTitle(Role.HUNTER);
        } else {
          this.owner.role.changeTitle(Role.EXPLORER);
        }
        this.hasEquippedWeapon = true;
      }

    } else if (item.isArmor() && !this.armor) {
      this.armor = item;
    } else if (item.isAmmunition() && !this.quiver) {
      this.quiver = item;
    } else {
      if (item.isAmmunition()) {
        this.stackInInventory(item);
      } else {
        // TODO: what happens if inventory full
        this.inventory.push(item);
      }
    }
  }

  combineInventoryStacks(stacked, incoming) {
    const remainder = Math.max(stacked.quantity + incoming.quantity - stacked.limit, 0);
    stacked.quantity = Math.min(stacked.quantity + incoming.quantity, stacked.limit);
    incoming.quantity = remainder;
  }

  stackInInventory(item) {
    // If existing ammo of this type is already in the quiver then fill it
    if (this.quiver.name == item.name) {
      this.combineInventoryStacks(this.quiver.ammunition, item.ammunition);
    }

    // If remaining ammo needs to be stacked
    if (item.ammunition.quantity > 0) {
      const existingStacks = this.inventory.filter(it => it.name == item.name);

      for (const stack of existingStacks) {
        this.combineInventoryStacks(stack.ammunition, item.ammunition);
        if (item.ammunition.quantity == 0) return;
      }

      // TODO: what happens if inventory full
      this.inventory.push(item);
    }
  }

  equipFromInventory(index) {
    if (this.inventory[index]) {
      const item = this.inventory[index];

      if (item.isArmor()) {
        this.equipArmor(item, index);
      } else if (item.isAmmunition()) {
        this.equipQuiver(item, index);
      } else {
        this.equipWeapon(item, index);
      }
    }
  }

  equipWeapon(item, index) {
    if (this.weapon) {
      this.inventory[index] = this.weapon;
    } else {
      this.inventory = this.inventory.filter(it => it !== item);
    }
    this.weapon = item;
  }

  equipArmor(item, index) {
    if (this.armor) {
      this.inventory[index] = this.armor;
    } else {
      this.inventory = this.inventory.filter(it => it !== item);
    }
    this.armor = item;
  }

  equipQuiver(item, index) {
    if (this.quiver) {
      this.inventory[index] = this.quiver;
    } else {
      this.inventory = this.inventory.filter(it => it !== item);
    }
    this.quiver = item;
  }

  unequipWeapon() {
    if (this.inventory.length < 10) {
      const weapon = this.weapon;
      this.inventory.push(weapon);
      this.weapon = false;
    }
  }

  unequipArmor() {
    if (this.inventory.length < 10) {
      const armor = this.armor;
      this.inventory.push(armor);
      this.armor = false;
    }
  }

  unequipQuiver() {
    if (this.inventory.length < 10) {
      const ammo = this.quiver;
      this.quiver = false;
      this.stackInInventory(ammo);
    }
  }

  dropItem(slot, index=0) {
    if (slot == Slots.WEAPON || slot == Slots.NONE) {
      const weapon = this.weapon;
      this.weapon = false;
      return weapon;
    } else if (slot == Slots.ARMOR) {
      const armor = this.armor;
      this.armor = false;
      return armor;
    } else if (slot == Slots.INVENTORY) {
      console.log("dropping")
      const item = this.inventory[index];
      if (item) {
        this.inventory = this.inventory.filter(it => it !== item);
        return item;
      }
    }
  }

  removeItem(id) {
    const item = this.inventory.find(it => it.name == id);
    this.inventory = this.inventory.filter(it => it !== item);
    return item;
  }

  getItem(id) {
    return this.inventory.find(it => it.name == id);
  }
}

export default Equipment;
